


























import Component, { mixins } from 'vue-class-component';
import BasePageMixin from '@/mixins/base-page-mixin';
import RuleServices, { RuleDto } from '@/services/rule';
import CategoryServices, { CategoryDto } from '@/services/category';
import { CategoryItem } from '@/interfaces/category-item';
import { State } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import ApproveModal from '../../components/approve-modal.vue';
import { confirmDelete } from '@/libs/decorator';
import moment from 'moment';
import RuleSetServices from '@/services/ruleSet';

@Component({
  components: { ApproveModal }
})
export default class Rule extends mixins(BasePageMixin) {
  bread = [{ name: '决策集' }];
  ruleSrv = new RuleServices();
  categorySrv = new CategoryServices();
  menu: CategoryItem[] = [
    {
      title: '决策集',
      icon: 'fa-cube',
      oprate: [
        { name: '新建目录', icon: 'fa-folder', key: 'addFolder' },
        { name: '刷新', icon: 'fa-refresh', key: 'refresh' }
      ],
      expand: true,
      children: []
    }
  ];

  ruleSetId: any = 0;
  ruleSetCode: any = '';
  async created() {
    this.ruleSetId = this.$route.query.ruleSetId;
    this.ruleSetCode = this.$route.query.ruleSetCode;
    this.getCategory();
  }

  setSrv = new RuleSetServices();
  async getSetInfo() {
    let id: any = this.$route.query.ruleSetId;
    if (!id) return false;
    let info = await this.setSrv.getInfo(id);
    this.bread = [{ name: '决策集' }, { name: info.ruleSetName }];
  }

  // 获取目录
  async getCategory() {
    this.menu[0].loading = true;
    let list = await this.categorySrv.getList({ categoryType_eq: 7, parentEntityId_eq: this.ruleSetId });
    this.menu[0].children = list.map((cate: CategoryDto) => ({
      title: cate.categoryName,
      icon: cate.icon,
      type: 'folder',
      record: cate,
      oprate: [
        { name: '新建决策', icon: 'fa-plus-circle', permissionKey: 'RULE_ADD', key: 'add' },
        { name: '编辑目录', icon: 'fa-edit', key: 'editFolder' },
        { name: '删除目录', icon: 'fa-trash', key: 'removeFolder' }
      ],
      expand: false,
      id: cate.id,
      children: []
    }));
    this.getSetInfo();
    this.menu[0].loading = false;
  }

  // 获取目录下文件
  async openFolderById(id: number) {
    let index = this.menu[0].children.findIndex((v: any) => v.id == id);
    this.menu[0].children[+index].loading = true;
    let list = await this.ruleSrv.getList({ ruleCategoryId_eq: id });
    let plist: object[] = [];
    list.forEach((rule: RuleDto) => {
      plist.push({
        title: rule.ruleName,
        key: this.getDetailUri(rule),
        icon: 'fa-registered',
        id: rule.id,
        record: rule,
        oprate: [
          { name: '编辑', icon: 'fa-edit', permissionKey: 'RULE_UPD', key: 'edit' },
          { name: '提交审批', icon: 'fa-share', permissionKey: 'RULE_REQ', key: 'approve' },
          { name: '执行陪跑', icon: 'fa-thermometer-0', permissionKey: 'RULE_TRAIL_EXEC', key: 'trail' },
          { name: '陪跑记录', icon: 'fa-hdd-o', permissionKey: 'RULE_TRAIL_LIST', key: 'trailRecord' },
          { name: '删除', icon: 'fa-trash', permissionKey: 'RULE_DEL', key: 'remove' }
        ]
      });
    });
    this.menu[0].children[+index].children = plist;
    this.menu[0].children[+index].expand = true;
    this.menu[0].children[+index].loading = false;
  }

  getDetailUri = (rule: RuleDto) => {
    this.ruleSetCode = this.$route.query.ruleSetCode;
    this.ruleSetId = this.$route.query.ruleSetId;
    return `/decision/rule/detail?id=${rule.id}&ruleSetCode=${this.ruleSetCode}&ruleSetId=${this.ruleSetId}`;
  };

  trailVisible: boolean = false;
  trailRuleInfo: RuleDto = {};
  dateRange: string[] = [];
  approveVisible: boolean = false;
  approveInfo: any = {};
  command(key: string, record: any) {
    let ruleSetCode = this.$route.query.ruleSetCode;
    switch (key) {
      case 'add': // 新建
        this.replaceUrl(`/decision/rule/add?ruleSetCode=${ruleSetCode}&categoryId=${record.id}&ruleSetId=${this.ruleSetId}`);
        break;
      case 'edit': // 编辑
        if (record.approveStatus == 2 || record.approveStatus == 3) {
          this.$message.error('当前状态不能编辑');
          return false;
        }
        this.replaceUrl(`/decision/rule/edit?id=${record.id}&ruleSetCode=${ruleSetCode}&ruleSetId=${this.ruleSetId}`);
        break;
      case 'remove': // 删除
        if ([1, 2, 3, 7].includes(record.approveStatus)) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        if ([4, 5].includes(record.approveStatus) && record.status == 0) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        this.removeRule(record.id);
        break;
      case 'approve': // 审批
        if (record.approveStatus > 1) {
          this.$message.error('当前状态不能提交审批');
          return false;
        }
        this.approveInfo = { type: 0, code: record.ruleCode, approveStatus: record.approveStatus, uri: this.getDetailUri(record) };
        this.approveVisible = true;
        break;
      case 'trail': // 执行陪跑
        this.trailRuleInfo = record;
        this.trailVisible = true;
        break;
      case 'trailRecord': // 执行陪跑
        this.$router.push(`/decision/trail?ruleCode=${record.ruleCode}`);
        break;
      case 'addFolder': // 新建目录
        this.folderId = 0;
        this.visible = true;
        break;
      case 'editFolder': // 编辑目录
        this.folderId = record.id;
        this.visible = true;
        break;
      case 'removeFolder': // 删除目录
        this.removeFolder(record.id);
        break;
      case 'expandFolder': // 展开目录
        this.openFolderById(record.id);
        break;
      case 'link':
        this.replaceUrl(record);
        break;
      case 'refresh':
        this.reloadMenu();
      default:
        break;
    }
  }

  trailLoading: boolean = false;
  async submitTrail() {
    let [startTime, endTime] = this.dateRange;
    if (!this.dateRange[1]) {
      this.$message.error('请选择日期区间');
      return false;
    }
    startTime = moment(startTime).format('YYYY-MM-DD');
    endTime = moment(endTime).format('YYYY-MM-DD');
    let { ruleCode, ruleName } = this.trailRuleInfo;
    this.trailLoading = true;
    let res = await this.ruleSrv.runTrail({ startTime, endTime, ruleCode, ruleName });
    if (res) {
      this.$message.success('操作成功');
      this.dateRange = [];
      this.trailVisible = false;
    }
    this.trailLoading = false;
  }

  async removeFolder(id: number) {
    let res = await this.categorySrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  @confirmDelete()
  async removeRule(id: number) {
    let res = await this.ruleSrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
    this.onDeleteRemoveTab('rule', id);
  }

  @State RELOAD_RULE_MENU: any;
  @Watch('RELOAD_RULE_MENU')
  reloadMenu() {
    // 重新载入目录下文件
    let openFolderIds: number[] = [];
    this.menu[0].children.forEach((v: any, index: number) => {
      if (v.expand) {
        openFolderIds.push(v.id);
      }
    });
    this.getCategory();
    openFolderIds.forEach(id => this.openFolderById(id));
  }

  @Watch('$route')
  onRouteChange() {
    if (/\/decision\/rule/.test(this.$route.path) ||
        /\/decision\/trail/.test(this.$route.path)) {
      this.ruleSetId = this.$route.query.ruleSetId;
      this.ruleSetCode = this.$route.query.ruleSetCode;
    }
  }

  @Watch('ruleSetId')
  async onIdChange() {
    this.getCategory();
  }
}
